module.exports = __webpack_public_path__ + "img/grillentanz2.0b7de170.jpg";